require('../../common/directives/jv.iframe-preview.directive');

angular.module('jv.search.resume-view-modal.directive', [
    'jv.iframe-preview.directive'
])
.controller('jvResumeViewModalController', [
    '$scope', '$http', '$q',
    function($scope, $http, $q) {
        var state = $scope.state = {};
        var ERROR = {
            noPreview: 1
        }
        function getResumeId(applicationId) {
            return $http.get([jvUrls.jhire, 'action/application', applicationId, 'resource/6'].join('/')).then(function(response) {
                var resourceInfo = response.data.resourceInfo;
                if (resourceInfo.eid) {
                    return resourceInfo.eid;
                }
                return $q.reject(ERROR.noPreview);
            });
        }

        function getResume(applicationId, fileId) {
            return $http.get([jvUrls.jhire, 'action/resource', applicationId, 'file', fileId, 'print'].join('/')).then(function(response) {
                return response.data;
            });
        }

        function loadPreview(applicationId) {
            state.loading = true;
            state.previewError = false;
            state.fileId = null;
            return getResumeId(applicationId).then(function(fileId) {
                state.fileId = fileId;
                return getResume(applicationId, fileId);
            }).then(function(preview) {
                state.preview = preview;
            }, function(err) {
                if (err === ERROR.noPreview) {
                    state.previewError = true;
                }
            }).finally(function() {
                state.loading = false;
            });
        }

        $scope.downloadLink = function() {
            if ($scope.activeApplication && state.fileId) {
                return [jvUrls.jhire, 'action/resource', $scope.activeApplication.EId, 'file', state.fileId + '?kind=Resume'].join('/');
            }
        };

        $scope.$watch('activeApplication', function(application) {
            if (application && $scope.show) {
                loadPreview(application.EId);
            }
        });

    }
])
.directive('jvResumeViewModal', [
    function() {
        return {
            scope: {
                hide: '&',
                show: '=',
                activeApplication: '=',
                candidateUrl: '&',
                requisitionUrl: '&',
                onNext: '&',
                onPrevious: '&',
                hasNext: '&',
                hasPrevious: '&'
            },
            controller: 'jvResumeViewModalController',
            templateUrl: 'modals/viewResume.html'
        }
    }
]);